export enum CustomEventName {
  // PMC
  LinkedInFollowSuccess = 'linkedin_follow_success',
  BasicDetailsSuccess = 'basic_details_success',
  CustomFormSubmission = 'custom_form_submission',
  ContactFormSubmission = 'contact_form_submission',
  ParcelsTracked = 'parcels_tracked', // TODO-GA3: deprecated
  PopUpViews = 'pop_up_views', // TODO-GA3: deprecated
  VerificationPopupViews = 'verification_popup_views', // TODO-GA3: deprecated
  BrowserVerificationClicks = 'browser_verification_clicks', // TODO-GA3: deprecated
  PlaybackVideoButtonViews = 'playback_video_button_views', // TODO-GA3: deprecated
  SubmissionLeadsForm = 'submission_leads_form',
  ViewLeadsForm = 'view_leads_form',
  InteractionLeadsForm = 'interaction_leads_form',
  ClickLeadsElements = 'click_leads_elements',
  ClickNavigationOpen = 'click_navigation_open',
  ClickNavigationItem = 'click_navigation_item',
  ClickSkipLinkedIn = 'click_skip_linkedin',
  ViewLinkedIn = 'view_linkedin',
  ViewBasicDetails = 'view_basic_details',
  ViewJoinUsPmc = 'view_join_us_pmc',
  SignUpSuccessPmc = 'sign_up_success_pmc',
  ClickJoinUsPmc = 'click_join_us_pmc',
  ClickRegistrationWall = 'click_registration_wall',
  ClickRegistrationBanner = 'click_registration_banner',
  ClickReportsSignups = 'click_reports_signups',
  ClickEventVideoSignups = 'click_event_video_signups',
  ClickReportDownloads = 'click_report_downloads',
  ClickHeaderSignups = 'click_header_signups',
  PMCSessions = 'pmc_sessions',
  ViewJoinUsReports = 'view_join_us_reports',
  ClickOverviewBannerSignups = 'click_overview_banner_signups',

  // PMT
  ClickCourierSite = 'click_courier_site',
  ImmediateFound = 'immediate_found',
  ImmediateNotFound = 'immediate_not_found',
  ParcelSearches = 'parcel_searches',
  InvalidParcelSearches = 'invalid_parcel_searches',
  ClickPmc = 'click_PMC',
  ClickParcel = 'click_parcel',
  UserSuggest = 'user_suggest',
  UserSuggestFound = 'user_suggest_found',
  ClickRemoveParcel = 'click_remove_parcel',
  RemoveParcelConfirm = 'remove_parcel_confirm',
  ClickPlus = 'click_plus',
  ClickFilter = 'click_filter',
  ClickSort = 'click_sort',
  ViewParcel = 'view_parcel',
  ViewJoinUs = 'view_join_us',
  ClickJoinUs = 'click_join_us',
  SignUpSuccess = 'sign_up_success',
  ViewNotified = 'view_notified',
  ClickNotified = 'click_notified',
  ClickUnsubAllConfirm = 'click_unsub_all_confirm',
  ClickEmailCta = 'click_email_cta',
  ViewBrowserVerification = 'view_browser_verification',
  ClickBrowserVerification = 'click_browser_verification',
  PMTSessions = 'pmt_sessions',
  ViewAffiliateSection = 'view_affiliate_section',
  AffiliateProductClick = 'affiliate_product_click',

  // Email Sync
  ViewLoginCta = 'view_login_cta',
  ClickLoginCta = 'click_login_cta',
  EsyncDisconnectConfirm = 'esync_disconnect_confirm',
  ConnectEmailSuccess = 'connect_email_success',
  ClickEsyncConnect = 'click_esync_connect',
  ViewEsyncCta = 'view_esync_cta',
  ClickEsyncCta = 'click_esync_cta',
  ViewEsyncAlerts = 'view_esync_alerts',
  ViewGrantAccessPopup = 'view_grant_access_popup',
  UnsubSummaryEmail = 'unsub_summary_email',
  ResubSummaryToggle = 'resub_summary_toggle',
}

export enum ParcelSearchesSource {
  PMC = 'PMC',
  PMT = 'PMT',
  AMP = 'AMP',
  EMAIL = 'EMAIL',
}
